import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
} from '@angular/core';
import { buttonStylesSAG, buttonStylesSHS } from './button.styles';
import { componentStylesByTheme } from '../utils/theme.utils';
import { THEME_TOKEN, Theme } from '../types/theme.types';

@Component({
  selector: 'sag-ui-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<button
    [disabled]="disabled || loading"
    [attr.data-square]="square"
    [attr.data-size]="size"
    [type]="type"
    [style]="style"
    [class]="styles"
    (blur)="handleBlur($event)"
    (focus)="handleFocus($event)"
  >
    <span *ngIf="iconPosition === 'start' && icon" [class]="iconClass"></span>
    <span [class]="loading ? 'opacity-0' : ''">
      <ng-content></ng-content>
    </span>
    <span *ngIf="iconPosition === 'end' && icon" [class]="iconClass"></span>
    <sag-ui-spinner
      size="sm"
      *ngIf="loading"
      class="absolute left-0 right-0 top-0 bottom-0 flex items-center justify-center"
    ></sag-ui-spinner>
  </button>`,
})
export class ButtonComponent {
  @Input() color: 'primary' | 'secondary' | 'tertiary' | 'danger' = 'primary';
  @Input() size: 'sm' | 'md' = 'md';
  @Input() iconPosition: 'start' | 'end' = 'start';
  @Input() disabled = false;
  @Input() loading = false;
  @Input() square: boolean | null = null;
  @Input() type = 'button';
  @Input() icon = '';
  @Input() style = '';
  @Input() class = '';

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() blur: EventEmitter<FocusEvent> = new EventEmitter<FocusEvent>();
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() focus: EventEmitter<FocusEvent> = new EventEmitter<FocusEvent>();

  constructor(@Inject(THEME_TOKEN) private readonly theme: Theme) {}

  protected handleBlur(event: FocusEvent): void {
    event.stopPropagation();
    this.blur.emit(event);
  }

  protected handleFocus(event: FocusEvent): void {
    event.stopPropagation();
    this.focus.emit(event);
  }

  protected get iconClass(): string {
    return `text-sm aspect-square icon-${this.icon} ${this.loading ? 'opacity-0' : ''}`;
  }

  protected get styles(): string {
    const buttonStyles = componentStylesByTheme(
      this.theme,
      buttonStylesSAG,
      buttonStylesSHS,
    );

    return (
      buttonStyles({ color: this.color }) + (this.class ? ` ${this.class}` : '')
    );
  }
}
